<ng-container *ngIf="card">
    <div class="homeCardButtons">
        <a (click)="onClick_cardDetail()" style="margin:0px 10px 0px 0px" [innerHTML]="'HOME_SLIDER_CARD_DETAIL_LABEL' | translate"></a>
        <a class="homeCardTopupBtn" (click)="onClick_favOnlineCharge()" [innerHTML]="'HOME_SLIDER_CARD_ONLINE_RECHARGE_LABEL' | translate"></a>
    </div>
</ng-container>